import { Component, Input } from '@angular/core';
import { MenuController } from '@ionic/angular';

@Component({
    selector: 'app-menu-button',
    templateUrl: './menu-button.component.html',
    styleUrls: ['./menu-button.component.scss'],
    standalone: false
})
export class MenuButtonComponent {
    @Input() menu = 'side-menu';

    constructor(private menuController: MenuController) { }

    toggleMenu(): void {
        this.menuController.open(this.menu);
    }
}
